import Moment from "react-moment";

const DateFormat = (props) => {
  return <Moment format="MMMM D, YYYY" utc>{props.date}</Moment>;
};

export default DateFormat;
